module.exports = __webpack_public_path__ + "OpenSans-SemiBold.e1c83f9474e0cc1d84a1.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/assets/fonts/open-sans/OpenSans-SemiBold.ttf
// module id = ../../../../../src/assets/fonts/open-sans/OpenSans-SemiBold.ttf
// module chunks = styles